import { formatDateTime } from '@formosa/shared/utils/formatDateTime';
import { normalizeSymbolCode } from '@formosa/shared/utils/marketThumb';
import {
  formatFundAmount,
  formatSignedFundAmount,
  getAmountTone,
  tf,
} from '../../constants/fundConstants';
import { calcPerpetualUnrealizedPnl } from '../../utils/perpetualPlayConfig';
import { resolvePositionDirectionLabel, resolvePositionPairLabel } from '../../constants/positionConstants';

/**
 * 資金頁永續「持有倉位」列表項。
 */
export default function WalletPerpetualOpenItem({ order, thumb, t }) {
  const symbol = normalizeSymbolCode(order?.marketSymbolCode || '');
  const currentPrice = thumb?.price ?? thumb?.close ?? order?.orderPrice;
  const unrealizedPnl = calcPerpetualUnrealizedPnl(
    order?.orderType,
    order?.orderPrice,
    currentPrice,
    order?.betAmount,
    order?.contractMultiple,
  );
  const pnlTone = getAmountTone(unrealizedPnl);
  const pair = resolvePositionPairLabel(order) || t('common.dash');
  const direction = resolvePositionDirectionLabel(t, 'perpetual', order);

  return (
    <li className="funds-position-item">
      <div className="funds-position-item__main">
        <div className="funds-position-item__left">
          <div className="funds-position-item__title">
            {pair}
            {' · '}
            {direction}
          </div>
          <div className="funds-position-item__meta">
            {tf(t, 'funds.positionAmountLabel', { amount: formatFundAmount(order?.betAmount ?? order?.margin) })}
          </div>
          <div className="funds-position-item__time">
            {order?.createTime ? formatDateTime(order.createTime) : t('common.dash')}
          </div>
        </div>
        <div className="funds-position-item__right">
          <div className={`funds-position-item__pnl is-${pnlTone}`}>
            {formatSignedFundAmount(unrealizedPnl)}
          </div>
          <div className="funds-position-item__status">{t('funds.perpetualStatusOpen')}</div>
        </div>
      </div>
    </li>
  );
}
